import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";

const UserList = ({ users, deleteUser, ...props }) => {
  return (
    <>
      <div className="container mx-auto">
        <div className="py-8">
          <div className="shadow rounded-lg">
            <table className="min-w-full leading-normal bg-white">
              <thead>
                <tr>
                  <th
                    scope="col"
                    className="px-5 py-3 bg-white border-b border-t border-gray-200 text-black text-left text-sm uppercase font-bold"
                  >
                    Редни бр.
                  </th>
                  <th
                    scope="col"
                    className="px-5 py-3 bg-white border-b border-t border-gray-200 text-black text-left text-sm uppercase font-bold"
                  >
                    Име
                  </th>
                  <th
                    scope="col"
                    className="px-5 py-3 bg-white border-b border-t border-gray-200 text-black text-left text-sm uppercase font-bold"
                  >
                    Презиме
                  </th>
                  <th
                    scope="col-span"
                    className="px-5 py-3 bg-white border-b border-t border-gray-200 text-black text-left text-sm uppercase font-bold"
                  >
                    Имејл адреса
                  </th>
                  <th
                    scope="col-span"
                    className="px-5 py-3 bg-white border-b border-t border-gray-200 text-black text-left text-sm uppercase font-bold"
                  >
                    Обновљено
                  </th>
                  <th
                    scope="col-span-2"
                    className="px-5 py-3 bg-white border-b border-t border-gray-200 text-black text-left text-sm uppercase font-bold"
                  >
                    Акција
                  </th>
                </tr>
              </thead>
              <tbody>
                {users.map((item, idx) => {
                  return (
                    <tr {...props}>
                      <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">
                          {idx + 1}
                        </p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">
                          {item.firstName}
                        </p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">
                          {item.familyName}
                        </p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">
                          {item.email}
                        </p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">
                          {moment(item.updated_at).format("DD.MM.YYYY")}
                        </p>
                      </td>
                      {item.role.type === "admin" ? (
                        <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                          <Link
                            to={`/editAdministrator/${item.id}`}
                            className="text-blue hover:text-indigo-900"
                          >
                            Подеси администратора
                          </Link>
                        </td>
                      ) : (
                        ""
                      )}
                      <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                        <button
                          className="text-red hover:text-red focus:outline-none"
                          onClick={() => deleteUser(item.id)}
                        >
                          {item.role.type === "admin"
                            ? "Обриши администратора"
                            : "Обриши корисник"}
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserList;
